/**
 * Subscribing to the server's push channel from a component.
 *
 * One socket per page, shared. A screen that opened its own would be a second
 * connection per modal, and a kiosk that reconnects them all at once when the
 * uplink returns.
 */
import { createContext, useContext, useEffect, useRef } from 'react'
import type { ServerEvent, ServerSocket } from './socket'

export const SocketContext = createContext<ServerSocket | null>(null)

export function useServerEvents(handler: (event: ServerEvent) => void): void {
  const socket = useContext(SocketContext)
  const latest = useRef(handler)
  latest.current = handler

  useEffect(() => {
    if (socket === null) return
    return socket.on((event) => latest.current(event))
  }, [socket])
}
